module.exports = __webpack_public_path__ + "static/media/recent-04.f5b58b67.jpg";